export default __webpack_public_path__ + "static/media/md-card-bg-DevOps.a761bfb8.png";